import { useEffect, useState } from 'react';
import {
    Table,
    Button,
    Modal,
    Form,
    Input,
    Upload,
    Popconfirm,
    message,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import PartnersApi from '../api/partners';

const Partners = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [modalVisible, setModalVisible] = useState(false);
    const [fileList, setFileList] = useState([]);
    const BASE_URL = process.env.REACT_APP_URL;

    const fetchAll = async () => {
        setLoading(true);
        const res = await PartnersApi.getAll();
        setList(res.data);
        setLoading(false);
    };

    useEffect(() => {
        fetchAll();
    }, []);

    const handleSubmit = async (values) => {
        try {
            const formData = new FormData();
            formData.append('name', values.name);
            const file = fileList[0]?.originFileObj;
            if (file) {
                formData.append('logo', file);
            }
            await PartnersApi.create(formData);
            message.success('Добавлено');
            closeModal();
            fetchAll();
        } catch {
            message.error('Ошибка при добавлении');
        }
    };

    const handleDelete = async (id) => {
        await PartnersApi.remove(id);
        fetchAll();
        message.success('Удалено');
    };

    const openModal = () => {
        setFileList([]);
        form.resetFields();
        setModalVisible(true);
    };

    const closeModal = () => {
        setModalVisible(false);
        setFileList([]);
    };

    const columns = [
        {
            title: 'Логотип',
            dataIndex: 'logo',
            render: (logo) =>
                logo ? (
                    <img
                        src={`${BASE_URL}${logo}`}
                        className="w-24 h-12 object-contain"
                        alt="partner"
                    />
                ) : (
                    '—'
                ),
        },
        {
            title: 'Название',
            dataIndex: 'name',
        },
        {
            title: 'Действия',
            render: (_, record) => (
                <Popconfirm title="Удалить?" onConfirm={() => handleDelete(record.id)}>
                    <Button danger size="small">
                        Удалить
                    </Button>
                </Popconfirm>
            ),
        },
    ];

    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Партнёры</h2>
                <Button type="primary" onClick={openModal}>
                    Добавить
                </Button>
            </div>

            <Table
                dataSource={list}
                columns={columns}
                rowKey="id"
                loading={loading}
            />

            <Modal
                title="Добавить партнёра"
                open={modalVisible}
                onCancel={closeModal}
                onOk={() => form.submit()}
                okText="Сохранить"
            >
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                    <Form.Item name="name" label="Название" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item label="Логотип">
                        <Upload
                            beforeUpload={() => false}
                            listType="picture"
                            fileList={fileList}
                            maxCount={1}
                            onChange={({ fileList }) => setFileList(fileList)}
                            accept="image/*"
                        >
                            <Button icon={<UploadOutlined />}>Загрузить</Button>
                        </Upload>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Partners;
